(function() {
    'use strict';

    angular
        .module('atheer.team', [

        ]);
})();
